import React from "react";

const ProjectOne = () => {
  return (
    <div className="my-4">
      <h1 className="text-5xl text-black  my-4">Screen Shots</h1>
      <div className="carousel w-full">
        <div id="item1" className="carousel-item w-full">
          <img src="https://i.ibb.co/Nsf9X1x/p2-1.png" className="mx-auto w-fit" />
        </div>
        <div id="item2" className="carousel-item w-full">
          <img src="https://i.ibb.co/0c4ThPZ/p2-2.png" className="mx-auto w-fit" />
        </div>
        <div id="item3" className="carousel-item w-full">
          <img src="https://i.ibb.co/r0rQ9y7/p2-3.png" className="mx-auto w-fit" />
        </div>
        <div id="item4" className="carousel-item w-full">
          <img src="https://i.ibb.co/Wpg8RDZ/p2-4.png" className="mx-auto w-fit" />
        </div>
      </div>
      <div className="flex justify-center w-full py-2 gap-2">
        <a href="#item1" className="btn btn-xs">
          1
        </a>
        <a href="#item2" className="btn btn-xs">
          2
        </a>
        <a href="#item3" className="btn btn-xs">
          3
        </a>
        <a href="#item4" className="btn btn-xs">
          4
        </a>
      </div>
      <div>
        <p className="text-black">
          Descriptions: • Implemented responsiveness along with elegant design
          showcasing products with an option to order and a login system. •
          Stored order information dynamically through a server on the database
          and managed orders with the option to cancel. • Cancelled orders get
          removed from database also. Products can be added by the user and be
          stored on the database as well as managed or deleted.
        </p>
      </div>
      <div className="flex flex-wrap justify-center my-10">
        <a
          className="btn btn-outline mr-4"
          href="https://book-verse-8b615.web.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Live Site{" "}
        </a>
        <a
          className="btn btn-outline mr-4"
          href="https://github.com/sasohan0/Book-Verse-Client"
          target="_blank"
          rel="noopener noreferrer"
        >
          Front-End Code
        </a>
        <a
          className="btn btn-outline"
          href="https://github.com/sasohan0/Book-Verse-Server"
          target="_blank"
          rel="noopener noreferrer"
        >
          Backend Code
        </a>
      </div>
    </div>
  );
};

export default ProjectOne;
